// extracted by mini-css-extract-plugin
export default {"wrapper":"LoggedInHeader-module__wrapper___cJL4p"};